import { Link } from "react-router-dom";
import { LayoutGrid, Bath, BedDouble } from "lucide-react";
import { formatPrice, coverOf } from "@/lib/api";

export const subtitleOf = (l) =>
  `${l.contratto === "Affitto" ? "In affitto" : "In vendita"} a ${l.comune}${l.zona ? ` zona ${l.zona}` : ""}`;

export const ListingCard = ({ l }) => (
  <article data-testid={`listing-card-${l.id}`} className="flex flex-col">
    <Link to={`/immobili/${l.id}`} className="group block">
      <div className="relative aspect-[453/280] overflow-hidden bg-gray-100">
        <img src={coverOf(l)} alt={l.titolo} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute top-0 left-0 bg-[var(--iv)] text-[#222] font-bold text-sm px-3.5 py-2">{l.riferimento}</span>
      </div>
      <div className="bg-[var(--iv)] text-white text-center px-3 py-2 font-tit uppercase">
        <h3 className="font-bold text-[15px] leading-snug tracking-wide">{l.titolo}</h3>
        <p className="font-bold text-[12px] tracking-wide">{subtitleOf(l)}</p>
      </div>
    </Link>
    <p className="text-sm leading-6 text-[#333] mt-3 line-clamp-5 flex-1">{l.descrizione}</p>
    <div className="mt-3 border-y border-gray-300 py-2 flex items-center justify-between gap-3">
      <div className="flex items-center gap-4 text-[15px] text-[#333]">
        <span className="flex items-center gap-1.5"><LayoutGrid className="w-4 h-4 fill-[#555] text-[#555]" />{l.mq ? `${l.mq} Mq` : "-"}{l.vani ? ` - ${l.vani} Vani` : ""}</span>
        {l.bagni ? <span className="flex items-center gap-1"><Bath className="w-4 h-4" />{l.bagni}</span> : null}
        {l.camere ? <span className="flex items-center gap-1"><BedDouble className="w-4 h-4" />{l.camere}</span> : null}
      </div>
      <p className="text-xl font-bold whitespace-nowrap" data-testid={`listing-price-${l.id}`}>{formatPrice(l)}</p>
    </div>
  </article>
);
